import { Koi } from '@ksyos/koi';
import type { IManagerRoleWithAuthorization } from '@common/interfaces';
import { ManagerAuthorization, ManagerRoleName } from '@common/enums/';
import type { ISchemaContainer } from './schemaContainer';

export type ManagerAuthorizationsGroupedByRole = { [key in ManagerRoleName]: IManagerRoleWithAuthorization[] };

export const managerAuthorizationsSchema: ISchemaContainer<ManagerAuthorizationsGroupedByRole> = {
    schema: Koi.object()
        .pattern(
            Koi.koi().enum(ManagerRoleName),
            Koi.array().items(
                Koi.object({
                    managerAuthorization: Koi.object({
                        name: Koi.koi().enum(ManagerAuthorization),
                    }),
                    name: Koi.koi().enum(ManagerRoleName),
                })
            )
        )
        .required()
        .min(1),
};
